module.exports = __webpack_public_path__ + "media/images/our_apps/android_decoration_md-87ad588b78eed759cbb12a86adfb5c45.png";